import { useRef } from 'react';
import * as R from 'remeda';
import { Skeleton } from '@rossum/ui/material';

const CellValueSkeleton = () => {
  const skeletonWidth = useRef(R.randomInteger(50, 150));

  return <Skeleton width={skeletonWidth.current} />;
};

export { CellValueSkeleton };
